import { render, staticRenderFns } from "./RevaluatePeriods.vue?vue&type=template&id=5f65e93c"
import script from "./RevaluatePeriods.vue?vue&type=script&lang=js"
export * from "./RevaluatePeriods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports